<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Add a New Company</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>This Company is a Sole Trader:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="IsSoleTrader"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="accounts.IsSoleTrader">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_name" v-model="accounts.company_name" v-validate="'required'"
                data-vv-as="Company Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_name')">{{
              errors.first("company_name") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Registration Number:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_registration_number" v-model="accounts.company_registration_number"
                v-validate="{ required: !this.accounts.IsSoleTrader }" data-vv-as="Company Registration Number" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_registration_number')">{{
              errors.first("company_registration_number") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_status" v-validate="'required'" v-model="accounts.status"
                data-vv-as="Company Status" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_status')">{{
              errors.first("company_status") }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Company Category:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="company_category" v-model="accounts.company_category"
                data-vv-as="Company Category" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('company_category')">{{
              errors.first("company_category") }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Registered Office -->
          <h5 class="mb-5">Registered Office Address</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="registered_office_address_1"
                v-model="accounts.registered_office_address_1" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.registered_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.registered_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.registered_office_city" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.registered_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.registered_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="accountAddRegisteredOfficeCountryRef" :chosen="selected_registered_office_country"
                class="searchbox" :list="getCountries" :searchOn="'registered_office_country'">
              </AccountAutocomplete>

              <!-- <vs-input
                class="w-full"
                v-model="accounts.registered_office_country"
              /> -->
            </div>
            <span v-if="registered_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              registered_office_country_validation }}</span>
          </div>
          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Head Office Address</h5>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Head Office Address is the Same As the Registered Office
                Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <input type="checkbox" v-model="headOfficeIsRegisteredOffice"/> -->
              <vs-switch vs-icon-on="check_box" vs-icon-off="block" v-model="accounts.headOfficeIsRegisteredOffice">
                <span slot="on">YES</span>
                <span slot="off">NO</span>
              </vs-switch>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 1:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_address_1" name="head_office_address_1" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 2:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_address_2" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address Line 3:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_address_3" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="head_office_city" data-vv-as="City" v-model="accounts.head_office_city" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_county" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" v-model="accounts.head_office_postcode" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="accountAddHeadOfficeCountryRef" :chosen="selected_head_office_country"
                class="searchbox" :list="getCountries" :searchOn="'head_office_country'">
              </AccountAutocomplete>




              <!-- <vs-input class="w-full" v-model="accounts.head_office_country" /> -->
            </div>
            <span v-if="head_office_country_validation" class="text-danger text-sm mt-2 ml-16">{{
              head_office_country_validation }}</span>

          </div>
          <vs-divider class="m-5" />
          <!-- Head Office -->
          <h5 class="mb-5">Company Website(s)</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="web" v-model="accounts.web" v-validate="'url:require_protocol'"
                data-vv-as="Website" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button @click="addWebsite" color="primary" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('web')">{{ errors.first("web") }}</span>
            </div>
          </div>
          <template v-if="accounts.websites.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added Website URLs</h6>
          </template>

          <template v-for="(website, index) in accounts.websites">
            <span :key="index" class="p-5">
              <p>
                {{ website }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedWeb(website)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />
          <!-- Head Office -->
          <h5 class="mb-5">Social Media Pages</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input class="w-full" name="linkedin" v-validate="'url:require_protocol'" v-model="accounts.linkedin" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addLinkedin" type="filled">Add</vs-button>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('linkedin')">{{ errors.first("linkedin")
              }}</span>

            </div>
          </div>
          <template v-if="accounts.linkedins.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added LinkedIn/Social URLs</h6>
          </template>

          <template v-for="(link, index) in accounts.linkedins">
            <span :key="index" class="p-5">
              <p>
                {{ link }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedLinkedin(link)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />

          <!-- Site Office -->
          <h5 class="mb-5">Site Office Address</h5>
          <template v-for="(site, index) in accounts.satellite">
            <div :key="index">
              <vs-divider class="m-5" />
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 1:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" name="satellite_office_address_1" data-vv-as="Address Line 1"
                    v-model="site.address_1" />
                </div>
                <vs-icon v-if="index > 0" class="ml-10 removeButton" @click="removeSelectedSiteAddress(site)"
                  color="success" icon="clear"></vs-icon>

              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 2:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_2" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Address Line 3:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.address_3" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>City:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.city" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>County:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.county" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Postcode:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-input class="w-full" v-model="site.postcode" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Telephone:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/2 w-full">                  <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="site.phone_code" />
</div>
                    <div class="vx-col sm:w-1/2 w-full">                  <vs-input @input="site.phone = site.phone.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" class="w-full" v-model="site.phone" />
</div>

                  </div>
                </div>
              </div>




            </div>
          </template>
          <vs-col class="mb-5" vs-offset="4" vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <vs-button color="primary" @click="addSiteOffice" type="filled">Add Satellite Office</vs-button>
          </vs-col>

          <vs-divider class="m-5" />

          <!-- Telephone -->
          <h5 class="mb-5">Telephone Number(s)</h5>
          <div class="vx-row mb-6">
           
            <div class="vx-col sm:w-1/6 w-full">
              <v-select name="phone_code" class="phone_code" label="name_with_code"
                                    :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="accounts.phone_code" />
              <!-- <vs-input class="w-full" v-model="accounts.phone" /> -->
            </div>
           
           
           
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input @input="accounts.phone = accounts.phone.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');" class="w-full" v-model="accounts.phone" />
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <v-select label="name" :options="accounts.phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="accounts.phoneType" />
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addPhoneNumbers" type="filled">Add</vs-button>
            </div>
          </div>
          <template v-if="accounts.joinedPhoneAndTypes.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added Phone Numbers</h6>
          </template>

          <template v-for="(phoneAndType, index) in accounts.joinedPhoneAndTypes">
            <span :key="index" class="p-5">
              <p>
                {{ phoneAndType }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedPhone(phoneAndType)" color="success"
                  icon="clear"></vs-icon>
              </p>
              <!-- <p>{{ phoneAndType }}</p> -->
            </span>
          </template>

          <!-- SIC CODE -->
          <h5 class="mb-5">Sic Code(s)</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">

              <AccountAutocomplete ref="SicCodeRef" class="searchbox" :chosen="selected_sic_code" :list="getSicCodes"
                :searchOn="'sic_codes'"></AccountAutocomplete>

              <!-- <vs-input type="number" class="w-full" v-model="accounts.sic_code" /> -->
            </div>
            <!-- <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" v-model="accounts.sic_code_description" />
            </div> -->
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button color="primary" @click="addSicCode" type="filled">Add</vs-button>
            </div>
          </div>
          <template v-if="accounts.joinedSicAndDescription.length > 0">
            <vs-divider class="p-5" />
            <h6 class="mb-2">Added Sic Codes</h6>
          </template>

          <template v-for="(sic, index) in accounts.joinedSicAndDescription">
            <span :key="index" class="p-5">
              <p>
                {{ sic }}
                <vs-icon class="ml-10 removeButton" @click="removeSelectedSic(sic)" color="success"
                  icon="clear"></vs-icon>
              </p>
            </span>
          </template>
          <vs-divider class="m-5" />
          <h5 class="mb-5">Other Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Registration Jurisdiction:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="RegistrationJurisdictionRef" :chosen="selected_registration_jurisdiction"
                class="searchbox" :list="getCountries" :searchOn="'registration_jurisdiction'">
              </AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Parent Company:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="ParentRef" class="searchbox" :chosen="selected_parent_company"
                :list="getParentCompany" :searchOn="'parent'"></AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vertical:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete ref="VerticalRef" class="searchbox" :chosen="selected_vertical" :list="getVerticals"
                :searchOn="'vertical'"></AccountAutocomplete>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Revenue:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/2 w-full">
                  <v-select label="label" :options="currencyCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="accounts.currency_code" />
                </div>

                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input type="number" class="w-full" v-model="accounts.revenue" />
                </div>
              </div>
              <span v-if="currency_code_validation" class="text-danger text-sm mt-2 ml-16">{{ currency_code_validation
              }}</span>


            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>No. of Employees:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input class="w-full" type="number" v-model="accounts.no_of_employees" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Notes:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-textarea class="w-full mb-2" v-model="accounts.notes" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
      <template v-if="accountExists">
        <vs-popup fullscreen :title="companyExistsAccountDescription.company_name" :active.sync="popupActive">
          <div class="flex justify-between flex-wrap">
            <vs-button class="mb-4 mr-6" @click="accept()" type="border">Accept</vs-button>
            <vs-button class="mb-4" type="border" @click="reject()" color="primary">Reject</vs-button>
          </div>
          <vs-list>
            <vs-list-header title="Key Company Details" color="success"></vs-list-header>
            <vs-list-item title="Company Name ">
              {{ companyExistsAccountDescription.company_name }}
            </vs-list-item>
            <vs-list-item title="Company Registration Number">
              {{ companyExistsAccountDescription.company_registration_number }}
            </vs-list-item>
            <vs-list-item title="Switchboard">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
            <vs-list-item title="Site Switchboard">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Site Switchboard' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
            <vs-list-item title="Others">
              <template v-for="(ph, index) in companyExistsAccountDescription.phone">
                <div :key="index">
                  <template v-for="(ph_type, index2) in ph.phone_type">
                    <div :key="index2" v-if="
                      ph_type.type == 'Others' &&
                      ph_type.phone_id == ph.id
                    ">
                      {{ ph.phone_no }}
                    </div>
                  </template>
                </div>
              </template>
            </vs-list-item>
          </vs-list>

          <vs-list>
            <vs-list-header title="Address" color="success"></vs-list-header>
            <vs-list-item title="Head Office Address">
              {{ companyExistsAccountDescription.head_office_address_1 }}
              {{ companyExistsAccountDescription.head_office_address_2 }}
              {{ companyExistsAccountDescription.head_office_address_3 }}
              {{ companyExistsAccountDescription.head_office_city }}
              {{ companyExistsAccountDescription.head_office_postcode }}
              {{ companyExistsAccountDescription.head_office_county }}
              {{ companyExistsAccountDescription.head_office_country }}
            </vs-list-item>
            <vs-list-item title="Registered Office Address">
              {{ companyExistsAccountDescription.registered_office_address_1 }}
              {{ companyExistsAccountDescription.registered_office_address_2 }}
              {{ companyExistsAccountDescription.registered_office_address_3 }}
              {{ companyExistsAccountDescription.registered_office_city }}
              {{ companyExistsAccountDescription.registered_office_postcode }}
              {{ companyExistsAccountDescription.registered_office_county }}
              {{ companyExistsAccountDescription.registered_office_country }}
            </vs-list-item>
            <template v-for="(satellite, index) in companyExistsAccountDescription.satellite_office">
              <vs-list-item :title="'Satellite Office ' + (index + 1)" :key="index">
                <template v-for="(phone, index3) in satellite.phone">
                  <div :key="index3" v-if="phone.satellite_office_id == satellite.id">
                    {{ phone.phone_no }}
                  </div>
                </template>
                {{ satellite.address_1 }}
                {{ satellite.address_2 }}
                {{ satellite.address_3 }}
                {{ satellite.town }}
                {{ satellite.county }}
                {{ satellite.postcode }}

                <template v-for="(country, index2) in satellite.country">
                  <div :key="index2" v-if="country.satellite_office_id == satellite.id">
                    {{ country.name_1 }}
                    {{ country.name_2 }}
                    {{ country.name_3 }}
                  </div>
                </template>
              </vs-list-item>
            </template>
          </vs-list>

          <vs-list>
            <vs-list-header title="Websites" color="success"></vs-list-header>
            <template v-for="(web, index) in companyExistsAccountDescription.web">
              <div :key="index">
                {{ web.url }}
              </div>
            </template>
          </vs-list>
          <vs-list>
            <vs-list-header title="LinkedIn" color="success"></vs-list-header>
            <template v-for="(linkedin, index) in companyExistsAccountDescription.linkedin">
              <div :key="index">
                {{ linkedin.url }}
              </div>
            </template>
          </vs-list>
        </vs-popup>
      </template>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import vSelect from "vue-select";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';
// Vue.component('vue-phone-number-input', VuePhoneNumberInput);
export default {
  data() {
    return {
      all_phone_codes: [],
      head_office_country_validation: null,
      companyExistsAccountDescription: {},
      selected_parent_company: null,
      selected_registration_jurisdiction: null,
      selected_vertical: null,
      selected_sic_code: null,
      selected_registered_office_country: null,
      selected_head_office_country: null,
      currencyCodes: [],
      abilities: null,
      currency_code_validation: null,

      registered_office_country_validation: null,
      accountDescription: [],
      accountExists: false,
      popupActive: false,
      websiteExists: false,
      linkedinExists: false,
      accounts: {
        company_name: null,
        registered_office_address_1: null,
        registered_office_address_2: null,
        registered_office_address_3: null,
        registered_office_city: null,
        registered_office_county: null,
        registered_office_postcode: null,
        registered_office_country: null,
        head_office_address_1: null,
        head_office_address_2: null,
        head_office_address_3: null,
        head_office_city: null,
        head_office_county: null,
        head_office_postcode: null,
        head_office_country: null,
        company_registration_number: null,
        registration_jurisdiction: null,
        company_category: null,
        status: null,
        parent: null,
        web: null,
        phone: null,
        phone_code: null,
        linkedin: null,
        country: null,
        main_counter: 0,
        satellite: [
          {
            counter: 0,
            address_1: null,
            address_2: null,
            address_3: null,
            city: null,
            county: null,
            postcode: null,
            country: null,
            phone: null,
            phone_code: null
          }
        ],
        IsSoleTrader: false,
        headOfficeIsRegisteredOffice: false,
        vertical: null,
        phoneTypes: [],
        phoneType: [],
        joinedPhoneAndTypes: [],
        joinedSicAndDescription: [],
        websites: [],
        linkedins: [],
        phoneWithTypes: [],
        sicWithDescription: [],
        IsSoleTraderFields: {},
        verticals: [],
        vertical: null,
        sic_code: null,
        sic_code_description: null,
        currency_code: null,
        revenue: null,
        no_of_employees: null,
        notes: null,
        account_user_id: null,

      },
      user_id: null,
      user_role: null
    };
  },
  components: {
    "v-select": vSelect,
    AccountAutocomplete
  },
  created() {
    var self = this

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    if (!moduleAccountsManagement.isRegistered) {


      defineAbilitiesFor().then(function (data) {
        self.abilities = data
      });
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
  },
  watch: {
    "accounts.IsSoleTrader"(val) {


      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value






      if (val) {
        this.accounts.IsSoleTraderFields = {
          company_name: this.accounts.company_name,
          head_office_country: this.accounts.head_office_country
        };


        if (this.accounts.head_office_country == null || this.accounts.head_office_country == '') {
          this.head_office_country_validation = 'The Head Office Country field is required'
          this.registered_office_country_validation = null
        } else {
          this.head_office_country_validation = null
        }



      } else {
        this.accounts.IsSoleTraderFields = {
          company_registration_number: this.accounts
            .company_registration_number,
          registered_office_country: this.accounts.registered_office_country
        };



        if (this.accounts.registered_office_country == null || this.accounts.registered_office_country == '') {
          this.registered_office_country_validation = 'The Registered Office Country field is required'
          this.head_office_country_validation = null
        } else {
          this.registered_office_country_validation = null
        }
      }



    },
    "accounts.headOfficeIsRegisteredOffice"(val) {
      if (val) {
        this.accounts.head_office_address_1 = this.accounts.registered_office_address_1;
        this.accounts.head_office_address_2 = this.accounts.registered_office_address_2;
        this.accounts.head_office_address_3 = this.accounts.registered_office_address_3;
        this.accounts.head_office_city = this.accounts.registered_office_city;
        this.accounts.head_office_county = this.accounts.registered_office_county;
        this.accounts.head_office_postcode = this.accounts.registered_office_postcode;
        // this.accounts.head_office_country = this.accounts.registered_office_country;


        if (moduleAccountsManagement.registered_office_country_selected) {
          this.selected_registered_office_country = moduleAccountsManagement.registered_office_country_selected
          this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.selected = moduleAccountsManagement.registered_office_country_selected
          this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = moduleAccountsManagement.registered_office_country_selected.name;
          this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value = moduleAccountsManagement.registered_office_country_selected.name;
          this.accounts.head_office_country = moduleAccountsManagement.registered_office_country_selected.name;
        }



      } else {
        this.accounts.head_office_address_1 = null;
        this.accounts.head_office_address_2 = null;
        this.accounts.head_office_address_3 = null;
        this.accounts.head_office_city = null;
        this.accounts.head_office_county = null;
        this.accounts.head_office_postcode = null;

        this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.selected = null
        this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value = null
        this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value = null
        this.accounts.head_office_country = null;
      }
    },
    // "accounts.head_office_country"(val) {
    //   this.checkCompanyExists();
    //   if (val) {
    //     // this.accounts.registration_jurisdiction = val;
    //   }
    // },
    // "accounts.company_registration_number"() {
    //   this.checkCompanyExists();
    // },
    // "accounts.websites"(val) {
    //   if (val) {
    //     var lastItem = val[val.length - 1];
    //     if (this.validDomain(lastItem)) {
    //       this.$store
    //         .dispatch("accountsManagement/checkWebsiteExists", lastItem)
    //         .then(res => {


    //           if (res.data.status == "fail") {
    //             this.websiteExists = true;
    //             this.$vs.dialog({
    //               type:'confirm',
    //               color: "primary",
    //               title: `Confirm`,
    //               text: "This value is already associated with " + res.data.company_name + ", do you wish to continue adding this value to this company as well?",
    //               accept: this.acceptDuplicateWeb
    //             });
    //             // var index = this.accounts.websites.indexOf(lastItem);
    //             // this.accounts.websites.splice(index, 1);
    //           } else {
    //             return;
    //           }
    //         })
    //         .catch(err => {

    //           console.log(err)
    //                 if (err.response.status === 401) {
    //         this.$router.replace("/login");
    // }
    //         });
    //     } else {
    //       var index = this.accounts.websites.indexOf(lastItem);
    //       this.accounts.websites.splice(index, 1);
    //       return false;
    //     }
    //   }
    // },
    // "accounts.linkedins"(val) {
    //   if (val) {
    //     var lastItem = val[val.length - 1];
    //     if (this.validDomain(lastItem)) {
    //       this.$store
    //         .dispatch("accountsManagement/checkLinkedinExists", lastItem)
    //         .then(res => {
    //           if (res.data.status == "fail") {
    //             this.linkedinExists = true;
    //             this.$vs.dialog({
    //               color: "primary",
    //               title: `Confirm`,
    //               text: "This linkedin already exists.",
    //               accept: (this.linkedinExists = false)
    //             });
    //             var index = this.accounts.linkedins.indexOf(lastItem);
    //             this.accounts.linkedins.splice(index, 1);
    //           } else {
    //             return;
    //           }
    //         })
    //         .catch(err => {
    //                 if (err.response.status === 401) {
    //         this.$router.replace("/login");
    // }
    //         });
    //     } else {
    //       var index = this.accounts.linkedins.indexOf(lastItem);
    //       this.accounts.linkedins.splice(index, 1);
    //       return false;
    //     }
    //   }
    // }
  },
  mounted() {
    this.getPhoneTypes();
    this.getCurrencyCodes()
    this.getAllPhoneCodes()
    // this.getVerticals();
  },
  methods: {
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function (ele) {
            if (ele.phone_code) {
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    acceptDuplicateWeb() {

      if (
        this.accounts.web &&
        !this.accounts.websites.includes(this.accounts.web)
      )
        this.accounts.websites.push(this.accounts.web);
      this.accounts.web = null

    },
    acceptDuplicateLinkedin() {

      if (
        this.accounts.linkedin &&
        !this.accounts.linkedins.includes(this.accounts.linkedin)
      )
        this.accounts.linkedins.push(this.accounts.linkedin);
      this.accounts.linkedin = null

    },
    goBack: function () {
      this.$router.go(-1);
    },
    removeSelectedSiteAddress(site) {
      this.accounts.satellite = this.accounts.satellite.filter(item => {
        return item.counter != site.counter;
      });
    },
    addSiteOffice() {
      this.accounts.satellite.push({
        counter: ++this.accounts.main_counter,
        address_1: null,
        address_2: null,
        address_3: null,
        city: null,
        county: null,
        postcode: null,
        country: null,
        phone: null,
        phone_code: null
      });
      // console.log(this.accounts.main_counter)
      // console.log(this.accounts.satellite)
    },

    removeSelectedLinkedin(url) {
      this.accounts.linkedins = this.accounts.linkedins.filter(item => {
        return item != url;
      });
    },
    removeSelectedPhone(selected) {
      this.accounts.joinedPhoneAndTypes = this.accounts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    removeSelectedSic(selected) {
      this.accounts.joinedSicAndDescription = this.accounts.joinedSicAndDescription.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    addPhoneNumbers() {
      if (
        this.accounts.phone &&
        this.accounts.phoneType &&
        !this.accounts.joinedPhoneAndTypes.includes(
         this.accounts.phoneType.name + ':' + this.accounts.phone_code.phone_code + " - " + this.accounts.phone
        )
      )
        this.accounts.joinedPhoneAndTypes.push(
          this.accounts.phoneType.name + ':' + this.accounts.phone_code.phone_code + " - " + this.accounts.phone 
        );
      let mappedPhoneTypes = {};
      mappedPhoneTypes.phone_code = this.accounts.phone_code.phone_code;
      mappedPhoneTypes.phone_no = this.accounts.phone;
      mappedPhoneTypes.phone_type = this.accounts.phoneType.slug;
      this.accounts.phoneWithTypes.push(mappedPhoneTypes);
      this.accounts.phone = null;
      this.accounts.phone_code = null;
      this.accounts.phoneType = null;
    },
    addSicCode() {
      // if (
      //   this.accounts.sic_code &&
      //   this.accounts.sic_code_description &&
      //   !this.accounts.joinedSicAndDescription.includes(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   )
      // )
      //   this.accounts.joinedSicAndDescription.push(
      //     this.accounts.sic_code + " - " + this.accounts.sic_code_description
      //   );
      // let mappedSic = {};
      // mappedSic.code = this.accounts.sic_code;
      // mappedSic.description = this.accounts.sic_code_description;

      this.accounts.joinedSicAndDescription.push(
        moduleAccountsManagement.sic_codes_selected.name
      );


      // console.log(moduleAccountsManagement.sic_codes_selected)
      this.accounts.sicWithDescription.push(moduleAccountsManagement.sic_codes_selected);

      this.$refs.SicCodeRef.$refs.suggestComponent.selected = null
      this.$refs.SicCodeRef.$refs.suggestComponent.input.value = null
      this.$refs.SicCodeRef.$refs.suggestComponent.value = null
      // this.selected_sic_code = null
      // this.accounts.sic_code = null;
      // this.accounts.sic_code_description = null;
    },
    addWebsite() {

      if (this.validDomain(this.accounts.web)) {
        this.$store
          .dispatch("accountsManagement/checkWebsiteExists", this.accounts.web)
          .then(res => {



            if (res.data.status == "fail") {
              this.websiteExists = true;
              this.$vs.dialog({
                type: 'confirm',
                color: "primary",
                title: `Confirm`,
                text: "This value is already associated with " + res.data.data.company_name + ", do you wish to continue adding this value to this company as well?",
                accept: this.acceptDuplicateWeb
              });
              // var index = this.accounts.websites.indexOf(lastItem);
              // this.accounts.websites.splice(index, 1);
            } else {
              if (
                this.accounts.web &&
                !this.accounts.websites.includes(this.accounts.web)
              )
                this.accounts.websites.push(this.accounts.web);
              this.accounts.web = null
            }
          })
          .catch(err => {
            if (err.response.status === 401) {
              this.$router.replace("/login");
            }
          });
      }











      // this.accounts.web = null;
    },
    addLinkedin() {


      this.$store
        .dispatch("accountsManagement/checkLinkedinExists", this.accounts.linkedin)
        .then(res => {
          if (res.data.status == "fail") {
            this.linkedinExists = true;
            this.$vs.dialog({
              type: 'confirm',
              color: "primary",
              title: `Confirm`,
              text: "This value is already associated with " + res.data.data.company_name + ", do you wish to continue adding this value to this company as well?",
              accept: this.acceptDuplicateLinkedin
            });
          } else {
            if (
              this.accounts.linkedin &&
              !this.accounts.linkedins.includes(this.accounts.linkedin)
            )
              this.accounts.linkedins.push(this.accounts.linkedin);
            this.accounts.linkedin = null;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });





    },
    submitForm() {


      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.registered_office_country = this.$refs.accountAddRegisteredOfficeCountryRef.$refs.suggestComponent.input.value

      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.value
      this.accounts.head_office_country = this.$refs.accountAddHeadOfficeCountryRef.$refs.suggestComponent.input.value




      this.accounts.account_user_id = this.user_id




      this.$validator.validateAll().then(result => {
        if (result) {
          if (Object.keys(this.accounts.IsSoleTraderFields).length === 0) {
            this.accounts.IsSoleTraderFields = {
              company_registration_number: this.accounts
                .company_registration_number,
              registered_office_country: this.accounts.registered_office_country
            };
          } else {

            this.accounts.IsSoleTraderFields = {
              company_name: this.accounts.company_name,
              head_office_country: this.accounts.head_office_country
            };

          }





          if (this.accounts.IsSoleTrader) {
            this.accounts.IsSoleTraderFields = {
              company_name: this.accounts.company_name,
              head_office_country: this.accounts.head_office_country
            };

            if (this.accounts.head_office_country == null || this.accounts.head_office_country == '') {
              this.head_office_country_validation = 'The Head Office Country field is required'
              this.registered_office_country_validation = null
              return false
            } else {
              this.head_office_country_validation = null
            }



          } else {
            this.accounts.IsSoleTraderFields = {
              company_registration_number: this.accounts
                .company_registration_number,
              registered_office_country: this.accounts.registered_office_country
            };


            if (this.accounts.registered_office_country == null || this.accounts.registered_office_country == '') {
              this.registered_office_country_validation = 'The Registered Office Country field is required'
              this.head_office_country_validation = null
              return false
            } else {
              this.registered_office_country_validation = null
            }

          }







          if (moduleAccountsManagement.autocomplete_selected) {
            this.accounts.parent =
              moduleAccountsManagement.autocomplete_selected.id;
          }
          if (moduleAccountsManagement.vertical_selected) {
            this.accounts.vertical =
              moduleAccountsManagement.vertical_selected.id;
          }
          if (moduleAccountsManagement.countries_selected) {
            this.accounts.registration_jurisdiction =
              moduleAccountsManagement.countries_selected.id;
          }
          if (moduleAccountsManagement.head_office_country_selected) {
            this.accounts.head_office_country =
              moduleAccountsManagement.head_office_country_selected.name;
          }

          if (moduleAccountsManagement.registered_office_country_selected) {
            this.accounts.registered_office_country =
              moduleAccountsManagement.registered_office_country_selected.name;
          }






          if (this.accounts.revenue != null && this.accounts.currency_code == null) {
            this.currency_code_validation = 'The currency code field is required'
            return false
          }



          this.addAccounts();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    addAccounts() {
    this.$vs.loading();
      this.$store
        .dispatch("accountsManagement/addAccount", this.accounts)
        .then(res => {
          if (res.data.status == "fail") {
            this.checkCompanyExists()
            this.$vs.notify({
              color: "danger",
              title: "Account",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Account",
              text: res.data.message
            });
            this.$router.push({ path: "/accounts" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        })
    },
    checkCompanyExists() {
      if (this.accounts.IsSoleTrader) {
        this.accounts.IsSoleTraderFields = {
          company_name: this.accounts.company_name,
          head_office_country: this.accounts.head_office_country
        };
      } else {
        this.accounts.IsSoleTraderFields = {
          company_registration_number: this.accounts
            .company_registration_number,
          registered_office_country: this.accounts.registered_office_country
        };
      }
      this.accounts.IsSoleTraderFields.is_sole_trader = this.accounts.IsSoleTrader
      this.$store
        .dispatch(
          "accountsManagement/checkCompanyExists",
          this.accounts.IsSoleTraderFields
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.companyExistsAccountDescription = res.data.data;
            this.accountExists = true;
            this.popupActive = true;
          } else {
            return;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPhoneTypes() {
      this.$store
        .dispatch("accountsManagement/getPhoneTypes")
        .then(res => {
          this.accounts.phoneTypes = res.data;
          this.accounts.phoneTypes = this.accounts.phoneTypes.filter(
            item => item.name != "Site Switchboard"
          );
          // console.log(this.accounts.phoneTypes)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getVerticals(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getVerticals", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.verticals;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].vertical
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCurrencyCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCurrencyCodes")
        .then(response => {
          let response_data = response.data
          let mappedArray = [];
          for (const property in response_data) {
            mappedArray.push({
              id: response_data[property].id,
              label: response_data[property].symbol + ' ' + response_data[property].name + ' ' + response_data[property].code
            });
          }
          this.currencyCodes = mappedArray
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSicCodes(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getSicCodes", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.sic_codes;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].code + ' - ' + data[property].description
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    accept() {
      this.popupActive = false
    },
    reject() {
      // this.popupActive = false;
      // this.$router.replace("/dashboard");
      this.$router.go(0);
    },
    getParentCompany(inputValue) {
      return this.$store
        .dispatch("accountsManagement/searchAutocomplete", inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
